import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import "../styles/angulos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import redondo from "../img/Redondo.png";
import cuadradado from "../img/Cuadrado.png";
import cuaretocido from "../img/Cuadrado_retorcido.png";
import anguloigual from "../img/Angulos_Lados_Iguales.png";
import angulodesigual from "../img/Angulos_Lados_desiguales.png";

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];
const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {/* ✅ Hacer que "Productos" sea clickeable y navegue */}
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item key={subIndex} href={subItem.link} style={{ color: "#fff" }}>
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
const TuboRedondo = () => {
  return (
    <section>
      <div className="servicios-container" style={{ textAlign: "center" }}>
        <div
          className="servicios-title"
          style={{
            marginTop: "130px",
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#f58634",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            padding: "10px",
            animation: "fadeIn 1s ease-in-out",
            textAlign: "center",
          }}
        >
          Ángulos y Soleras
        </div>
      </div>
      <div className="row" style={{ marginTop: '50px', display: 'flex', alignItems: 'center' }}>
        {/* Descripción del producto con imágenes alineadas */}
        <div className="col-md-4 d-flex flex-column justify-content-center align-items-center"
          style={{ height: 'auto', textAlign: 'justify' }}>
          <p style={{ marginLeft: '10px', textAlign: 'justify' }}>
            Los ángulos y soleras son perfiles metálicos ampliamente utilizados en la construcción y la
            industria. Los ángulos tienen una forma de “L” con dos alas que forman un ángulo de 90 grados,
            proporcionando resistencia estructural en marcos, soportes y refuerzos. Las soleras son barras
            planas de acero que se emplean en la fabricación de estructuras, uniones y refuerzos, destacando
            por su versatilidad y facilidad de manipulación.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px', zIndex: '10' }}>
            <img src={anguloigual} alt="Angulo Lados Iguales" className="img-fluid custom-img" />
            <img src={angulodesigual} alt="Angulo Lados Iguales" className="img-fluid custom-img" />
          </div>
          <br />
          <br />
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px', zIndex: '10' }}>
            <img src={redondo} alt="Redondo" className="img-fluid custom-img" />
            <img src={cuadradado} alt="Cuadrado" className="img-fluid custom-img" />
            <img src={cuaretocido} alt="Cuadro Retorcido" className="img-fluid custom-img" />
          </div>
        </div>

        {/* Tabla del producto */}
        <div className="col-md-8">
          {/* Contenedor con scroll para las tablas */}
          <div style={{ maxHeight: '70vh', overflowY: 'auto', maxWidth: '100%', margin: '0 auto' }}>
            <table className="table table-striped table-bordered" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <thead>
                <tr>
                  <th colspan="7" class="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background: '#f58634' }}>
                    Ángulos (lados iguales)
                  </th>
                </tr>
                <tr>
                  <th style={{ background: '#f58634', color: '#fff' }} colspan="2">Pulg.</th>
                  <th style={{ background: '#f58634', color: '#fff' }} colspan="2">mm.</th>
                  <th style={{ background: '#f58634', color: '#fff' }}>Peso</th>
                </tr>
                <tr style={{ background: '#f58634' }}>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor (k)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Ancho (bf)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor (k)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Ancho(bf)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>kg./m</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="3">cal.12
                    (.109") x</td>
                  <td>1 1/4</td>
                  <td rowspan="3">2.77 x</td>
                  <td>25.40</td>
                  <td>1.06</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4</td>
                  <td>31.75</td>
                  <td>1.32</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>38.10</td>
                  <td>1.61</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="5">1/8 x</td>
                  <td>3/4</td>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="5">3.18 x</td>
                  <td>19.05</td>
                  <td>0.88</td>
                </tr>
                <tr style={{ background: "#f0f0f0f7" }}>
                  <td>1</td>
                  <td>25.40</td>
                  <td>1.19</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4</td>
                  <td>31.75</td>
                  <td>1.50</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>38.10</td>
                  <td>1.83</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2</td>
                  <td>50.80</td>
                  <td>2.46</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="2">5/32 x</td>
                  <td>1 1/2</td>
                  <td rowspan="2">3.96 x</td>
                  <td>38</td>
                  <td>2.26</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2</td>
                  <td>50.8</td>
                  <td>3.04</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="6">3/16 x</td>
                  <td>1</td>
                  <td rowspan="6">4.76 x</td>
                  <td>25.40</td>
                  <td>1.73</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4</td>
                  <td>31.75</td>
                  <td>2.20</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>38.10</td>
                  <td>2.20</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2</td>
                  <td>50.80</td>
                  <td>3.63</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2 1/2</td>
                  <td>63.50</td>
                  <td>4.57</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3</td>
                  <td>76.20</td>
                  <td>5.52</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="8">1/4 x</td>
                  <td>1</td>
                  <td rowspan="8">6.35 x</td>
                  <td>25.40</td>
                  <td>2.22</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4</td>
                  <td>31.75</td>
                  <td>2.86</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>38.10</td>
                  <td>3.48</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2</td>
                  <td>50.80</td>
                  <td>4.75</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2 1/2</td>
                  <td>63.50</td>
                  <td>6.10</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3</td>
                  <td>76.20</td>
                  <td>7.29</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3 1/2</td>
                  <td>88.90</td>
                  <td>8.63</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>4</td>
                  <td>101.60</td>
                  <td>9.82</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="6">5/16 x</td>
                  <td>2</td>
                  <td rowspan="6">7.94 x</td>
                  <td>50.80</td>
                  <td>5.83</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2 1/2</td>
                  <td>63.50</td>
                  <td>7.44</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3</td>
                  <td>76.20</td>
                  <td>9.08</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3 1/2</td>
                  <td>88.90</td>
                  <td>10.71</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>4</td>
                  <td>101.60</td>
                  <td>12.20</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>15.3</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="6">3/8 x</td>
                  <td>2</td>
                  <td rowspan="6">9.53 x</td>
                  <td>50.80</td>
                  <td>6.99</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2 1/2 </td>
                  <td>63.50</td>
                  <td>7.44</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3</td>
                  <td>76.20</td>
                  <td>10.71</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>4</td>
                  <td>101.60</td>
                  <td>14.58</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>18.3</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.40</td>
                  <td>22.17</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="5">1/2 x</td>
                  <td>3</td>
                  <td rowspan="5">12.70 x</td>
                  <td>76.20</td>
                  <td>13.99</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>4</td>
                  <td>101.60</td>
                  <td>19.05</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>24.11</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.40</td>
                  <td>29.17</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>203</td>
                  <td>39.30</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="3">5/8 x</td>
                  <td>4</td>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="3">15.88 x</td>
                  <td>101.60</td>
                  <td>23.36</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>6</td>
                  <td>152.40</td>
                  <td>36.01</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>8</td>
                  <td>203.20</td>
                  <td>48.66</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="3">5/8 x</td>
                  <td>4</td>
                  <td rowspan="3">15.88 x</td>
                  <td>101.60</td>
                  <td>23.36</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.40</td>
                  <td>36.01</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>203.20</td>
                  <td>48.66</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="3">3/4 x</td>
                  <td>5</td>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="3">19.05 x</td>
                  <td>127</td>
                  <td>35.12</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>6</td>
                  <td>152.40</td>
                  <td>42.71</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>8</td>
                  <td>203.20</td>
                  <td>57.89</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>7/8 x</td>
                  <td>8</td>
                  <td>22.23</td>
                  <td>203</td>
                  <td>66.97</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="2">1</td>
                  <td>6</td>
                  <td>25.40</td>
                  <td>152.40</td>
                  <td>55.66</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>24.4</td>
                  <td>203</td>
                  <td>75.90</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }}>1 1/8 x</td>
                  <td>8</td>
                  <td>28.56</td>
                  <td>203</td>
                  <td>84.68</td>
                </tr>
              </tbody>
            </table>
            <table className="table table-striped table-bordered" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <thead>
                <tr>
                  <th colspan="7" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background: '#f58634' }}>
                    Ángulos (lados desiguales)
                  </th>
                </tr>

                <tr>
                  <th style={{ background: '#f58634', color: '#fff' }} colspan="2">Pulg.</th>
                  <th style={{ background: '#f58634', color: '#fff' }} colspan="2">mm.</th>
                  <th style={{ background: '#f58634', color: '#fff' }}>Peso</th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor (k)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Dimension (d x bf)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor (k)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Ancho(bf)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>kg./m</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td>3/16</td>
                  <td>3 x 2</td>
                  <td>4.76</td>
                  <td>76.2 x 50.8</td>
                  <td>4.57</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="2">1/4</td>
                  <td>3 x 2</td>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="2">6.35</td>
                  <td>76.2 x 50.8</td>
                  <td>6.70</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>4 x 3</td>
                  <td>101.6 x 76.2</td>
                  <td>8.63</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }}>5/16</td>
                  <td>4 x 3</td>
                  <td style={{ background: "#f0f0f0f7" }}>7.90</td>
                  <td>101.6 x 76.2</td>
                  <td>8.63</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3/8</td>
                  <td>6 x 4</td>
                  <td>9.53</td>
                  <td>152.4 x 101.6</td>
                  <td>18.30</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1/2</td>
                  <td>6 x 4</td>
                  <td>12.70</td>
                  <td>152.4 x 101.6</td>
                  <td>24.11</td>
                </tr>
              </tbody>
            </table>
            <p style={{ fontSize: "20px;" }}><strong>Nota:</strong> Peso de acuerdo a la norma ASTM-A-6,
              grado A-36, G. 50</p>
            <table className="table table-striped table-bordered" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <thead>
                <tr>
                  <th colspan="7" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background: '#f58634' }}>
                    Soleras
                  </th>
                </tr>

                <tr>
                  <th style={{ background: '#f58634', color: '#fff' }} colspan="2">Pulg.</th>
                  <th style={{ background: '#f58634', color: '#fff' }} colspan="2">mm.</th>
                  <th style={{ background: '#f58634', color: '#fff' }}>Peso</th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Dimension</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Ancho</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>kg./m</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="6">1/8</td>
                  <td>1/2</td>
                  <td rowspan="6">3.2</td>
                  <td>12.7</td>
                  <td>0.31</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3/4</td>
                  <td>19.1</td>
                  <td>0.47</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1</td>
                  <td>25.4</td>
                  <td>0.63</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4</td>
                  <td>31.7</td>
                  <td>0.79</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>38.1</td>
                  <td>0.95</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2</td>
                  <td>50.8</td>
                  <td>1.26</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="7">3/16</td>
                  <td>1/2</td>
                  <td rowspan="7">4.8</td>
                  <td>12.7</td>
                  <td>0.47</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3/4</td>
                  <td>19.1</td>
                  <td>0.71</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1</td>
                  <td>25.4</td>
                  <td>0.94</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4</td>
                  <td>31.7</td>
                  <td>1.18</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>38.1</td>
                  <td>1.42</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2</td>
                  <td>50.8</td>
                  <td>1.90</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2 1/2</td>
                  <td>63.5</td>
                  <td>2.37</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="14" style={{ background: "#f0f0f0f7" }}>1/4</td>
                  <td>1/2</td>
                  <td rowspan="14" style={{ background: "#f0f0f0f7" }}>6.3</td>
                  <td>12.7</td>
                  <td>0.63</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3/4</td>
                  <td>19.1</td>
                  <td>0.95</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1</td>
                  <td>25.4</td>
                  <td>1.26</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/4</td>
                  <td>31.7</td>
                  <td>1.58</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/2</td>
                  <td>38.1</td>
                  <td>1.90</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2</td>
                  <td>50.8</td>
                  <td>2.53</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2 1/2</td>
                  <td>63.5</td>
                  <td>3.17</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3</td>
                  <td>76.2</td>
                  <td>3.79</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>4</td>
                  <td>101.6</td>
                  <td>5.06</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>6.32</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.4</td>
                  <td>7.59</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>203.2</td>
                  <td>10.12</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>10</td>
                  <td>254</td>
                  <td>12.65</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>12</td>
                  <td>304.8</td>
                  <td>15.18</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="8" style={{ background: "#f0f0f0f7" }}>5/16</td>
                  <td>1</td>
                  <td rowspan="8" style={{ background: "#f0f0f0f7" }}>7.9</td>
                  <td>25.4</td>
                  <td>1.58</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>38.1</td>
                  <td>2.37</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2</td>
                  <td>50.8</td>
                  <td>3.16</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2 1/2</td>
                  <td>63.5</td>
                  <td>3.95</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3</td>
                  <td>76.2</td>
                  <td>4.79</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>4</td>
                  <td>101.6</td>
                  <td>6.32</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>7.90</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>6</td>
                  <td>152.4</td>
                  <td>9.49</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="12" style={{ background: "#f0f0f0f7" }}>3/8</td>
                  <td>1</td>
                  <td rowspan="12" style={{ background: "#f0f0f0f7" }}>9.5</td>
                  <td>25.4</td>
                  <td>1.90</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/4</td>
                  <td>31.7</td>
                  <td>2.37</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/2</td>
                  <td>38.1</td>
                  <td>2.84</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2</td>
                  <td>50.8</td>
                  <td>3.79</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2 1/2</td>
                  <td>63.5</td>
                  <td>4.74</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3</td>
                  <td>76.2</td>
                  <td>5.69</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>4</td>
                  <td>101.6</td>
                  <td>7.59</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>9.49</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.4</td>
                  <td>11.38</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>203.2</td>
                  <td>15.19</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>10</td>
                  <td>254</td>
                  <td>18.99</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>12</td>
                  <td>304.8</td>
                  <td>22.78</td>
                </tr>

                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="10" style={{ background: "#f0f0f0f7" }}>1/2</td>
                  <td>1 1/2</td>
                  <td rowspan="10" style={{ background: "#f0f0f0f7" }}>12.7</td>
                  <td>38.1</td>
                  <td>38.1</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2</td>
                  <td>50.8</td>
                  <td>5.06</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2 1/2</td>
                  <td>63.5</td>
                  <td>6.32</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3</td>
                  <td>76.2</td>
                  <td>7.59</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>4</td>
                  <td>101.6</td>
                  <td>10.12</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>12.65</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.4</td>
                  <td>15.18</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>203.2</td>
                  <td>20.25</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>10</td>
                  <td>254</td>
                  <td>25.31</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>12</td>
                  <td>304.8</td>
                  <td>30.39</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="4" style={{ background: "#f0f0f0f7" }}>5/8</td>
                  <td>4</td>
                  <td rowspan="4" style={{ background: "#f0f0f0f7" }}>15.9</td>
                  <td>101.6</td>
                  <td>12.65</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>15.81</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.4</td>
                  <td>18.97</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>203.2</td>
                  <td>25.31</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="6" style={{ background: "#f0f0f0f7" }}>3/4</td>
                  <td>2 1/2</td>
                  <td rowspan="6" style={{ background: "#f0f0f0f7" }}>19.05</td>
                  <td>63.5</td>
                  <td>9.49</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3</td>
                  <td>76.2</td>
                  <td>11.39</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>4</td>
                  <td>101.6</td>
                  <td>15.18</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>5</td>
                  <td>127</td>
                  <td>18.98</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6</td>
                  <td>152.4</td>
                  <td>22.77</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>8</td>
                  <td>203.2</td>
                  <td>30.38</td>
                </tr>
              </tbody>
            </table>

            <table className="table table-striped table-bordered" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <thead>
                <tr>
                  <th colspan="7" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background: '#f58634', color: '#fff' }}>
                    Redondo, Cuadrado, Cuadro Retorcido
                  </th>
                </tr>

                <tr>
                  <th style={{ background: '#f58634', color: '#fff' }} colspan="3">Pulg.</th>
                  <th style={{ background: '#f58634', color: '#fff' }}>Redondos</th>
                  <th style={{ background: '#f58634', color: '#fff' }}>Cuadrados</th>
                  <th style={{ background: '#f58634', color: '#fff' }}>Cuadrado retorcido</th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>pulg.</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>milésimas.</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>mm.</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>kg./m.</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>kg./m</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>kg./m</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td>12 mm.</td>
                  <td>0.472</td>
                  <td>12.00</td>
                  <td>-</td>
                  <td>1.14</td>
                  <td>1.14</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3/8</td>
                  <td>0.375</td>
                  <td>9.53</td>
                  <td>0.56</td>
                  <td>0.71</td>
                  <td>0.71</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1/2</td>
                  <td>0.500</td>
                  <td>12.70</td>
                  <td>0.99</td>
                  <td>1.26</td>
                  <td>1.26</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>5/8</td>
                  <td>0.625</td>
                  <td>15.88</td>
                  <td>1.55</td>
                  <td>1.98</td>
                  <td>1.98</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3/4</td>
                  <td>0.750</td>
                  <td>19.05</td>
                  <td>2.24</td>
                  <td>2.85</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>7/8</td>
                  <td>0.875</td>
                  <td>22.23</td>
                  <td>3.04</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1</td>
                  <td>1.000</td>
                  <td>25.40</td>
                  <td>3.97</td>
                  <td>5.06</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/8</td>
                  <td>1.125</td>
                  <td>28.58</td>
                  <td>5.03</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/4</td>
                  <td>1.250</td>
                  <td>31.75</td>
                  <td>6.21</td>
                  <td>7.91</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 3/8</td>
                  <td>1.375</td>
                  <td>34.93</td>
                  <td>7.51</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2</td>
                  <td>1.500</td>
                  <td>38.10</td>
                  <td>8.94</td>
                  <td>11.38</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 3/4</td>
                  <td>1.750</td>
                  <td>44.45</td>
                  <td>12.17</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2</td>
                  <td>2.000</td>
                  <td>50.80</td>
                  <td>15.90</td>
                  <td>20.24</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2 1/2</td>
                  <td>2.500</td>
                  <td>63.50</td>
                  <td>24.84</td>
                  <td>31.62</td>
                  <td>-</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3</td>
                  <td>3.000</td>
                  <td>76.20</td>
                  <td>35.76</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
            <p style={{ fontSize: "20px;" }}><strong>Nota: </strong>Se manejan a 6.10 m. de largo en grado ASTM A-36</p>

          </div>
        </div>
      </div>
    </section >
  );
}

const Servicios = () => {
  return (
    <section className="nservicios text-center my-5">
      <h3>Nuestros Servicios</h3>
      <div className="servicios-container">
        <Link to='/servicio#corte_laser' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Corte Láser</p>
            <img src={require("../img/laser.png")} alt="Corte Láser" />
          </div>
        </Link>
        <Link to='/servicio#corte_tubo' style={{ textDecoration: 'none' }} >
          <div className="servicio">
            <p>Corte de Tubo</p>
            <img src={require("../img/corte_recto.png")} alt="Corte Recto" />
          </div>
        </Link>
        <Link to='/servicio#doblez' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Doblez de Lámina</p>
            <img src={require("../img/dobladora-lamina.png")} alt="Doblez de Lámina" />
          </div>
        </Link>
        <Link to='/servicio#doblez-tubo' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p style={{ fontSize: "13px" }}>Doblez de Tubo</p>
            <img src={require("../img/dobladora-tubo.JPG")} alt="Doblez de Tubo" />
          </div>
        </Link>

      </div>
    </section>
  );
};

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Angulos = () => {
  return (
    <div>
      <NavBar />
      <TuboRedondo />
      <Servicios />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Angulos;
